// extracted by mini-css-extract-plugin
module.exports = {"container":"vaa2FGA5","buttonContainer":"ajRhBrav","button":"Vni8xZq_","icon":"yj5ddXp2","text":"ZYb4X68d","subtext":"__6m_HwDU4","tooltip":"uaNBx2Oi"};